export enum ScreenBreakpoints {
  mobile = 480,
  tablet = 1024,
}

const _fajkfka = '';
